module.exports = __webpack_public_path__ + "static/img/9.060e3b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/zh/9.png
// module id = Dslw
// module chunks = 0